import React from 'react'
import Figure from './Figure'
import BlockFile from './block-file'
import BlockFaq from './block-faq'

const serializers = {
  types: {
    authorReference: ({node}) => <span>{node.author.name}</span>,
    mainImage: Figure,
    fileComponent: BlockFile,
    faqs: BlockFaq
  }
}

export default serializers
